export const STATUS = {
  AVAILABLE: 'Disponível',
  MAINTENANCE: 'Manutenção',
};

export interface IRenderAvailableOrMaintenance {
  value: string;
  weight: number;
  size: number;
}
